<div class="container-fluid p-6">
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">ENTWICKLUNG VON ZWEI HOCHPERFORMANTEN SOFTWARE-KOMPONENTEN FÜR DEN ECHTZEITBETRIEB</h6>
            <h2>HOCHPERFORMANTE CHART- UND DATAGRID-KOMPONENTE</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                Die HD Automation GmbH wurde im Jahr 2002 in Hannover gegründet und hat sich weltweit als zuverlässiger Lieferant von Softwarelösungen für Prüfstände und Produktionsanlagen etabliert. Der Unternehmensschwerpunkt liegt in der Entwicklung moderner Mess‐ und Steuerungsprogramme, die zur Erprobung und Qualitätssicherung neuer Produkte an Prüfständen unterschiedlicher Bauart benötigt werden. Zu den Kunden der HD Automation gehören insbesondere Unternehmen der Automobilindustrie sowie deren Zulieferer, dessen Standorte in Deutschland, China, USA, Indien, Schweden, Slowakei und vielen weiteren Ländern durch die HD Automation beliefert werden.
            </p>
            <p>
                Für die Visualisierung und Bearbeitung von Millionen von Datenpunkten in ihrer Mess- und Steuersoftware stieß HD Automation mit den am Markt verfügbaren Komponenten an technische Grenzen. Daher wurde ein Projekt initiiert, um eigene, hochperformante Software-Komponenten zu entwickeln, die zudem browserbasiert und plattformübergreifend einsetzbar sind.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="ref-page-header-image"
             style="background-image: url(/assets/images/references/ref-hipercomponents.jpg)"></div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Für das DataGrid und die Chart-Komponente war die Entwicklung hochperformanter Lösungen erforderlich, welche in der Lage sind, Millionen von Datensätzen innerhalb weniger Millisekunden zu verarbeiten und flüssig darzustellen.
            </p>
            <p>
                Dabei lag ein besonderer Fokus darauf, eine maximale Performance auch auf leistungsschwächeren Systemen wie beispielsweise Embedded-PCs und kompakten Industrie-PCs zu gewährleisten. Zusätzlich wurde großer Wert auf eine intuitive Bedienbarkeit der Komponenten gelegt, um eine optimale User Experience sicherzustellen.
            </p>
            <img src="/assets/images/references/ref-hipercontrols-art.webp" class="img-fluid" style="max-height: min( 66.6vh, 66.6vw)"/>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Durch den Verzicht auf unnötige Abstraktionsschichten und die direkte Entwicklung mit WebGL gelang es der aheadware GmbH, zwei innovative Software-Komponenten zu realisieren, die nicht nur alle Anforderungen erfüllten, sondern neue Maßstäbe setzen. Die Chart-Komponente ermöglicht die flüssige Darstellung und Verarbeitung von Millionen Datenpunkten in Echtzeit, während die DataGrid-Komponente große Datenmengen performant visualisiert und gleichzeitig eine direkte Bearbeitung im Browser ermöglicht.
            </p>
            <p>
                Mit beeindruckend flüssigen Animationen und außergewöhnlicher Performance übertreffen beide Lösungen vergleichbare Desktop-Anwendungen in Effizienz und Flexibilität. Diese bislang einzigartige Innovation eröffnet völlig neue Möglichkeiten in der Datenvisualisierung und -bearbeitung und erfüllt dabei höchste Ansprüche an Modernität und Zukunftssicherheit.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/WebGL WebGPU@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-12">
            <div class="p-2 p-lg-5" style="border: 1px solid white;">
                <p>
                    “Die Zusammenarbeit mit der aheadware GmbH hat unsere Erwartungen nicht nur erfüllt, sondern deutlich übertroffen. Die entwickelten Komponenten überzeugen durch herausragende Performance und intuitive Benutzerfreundlichkeit. Besonders bemerkenswert ist die nahtlose Verarbeitung und Darstellung von Millionen Datenpunkten im Browser – eine Lösung, die neue Maßstäbe setzt und ihresgleichen sucht.”
                </p>
                <p>
                    <i>Dipl.-Ing. Oliver Harrendorf, CEO</i>
                </p>
            </div>
        </div>
    </div>
</div>
